/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompletedPaymentResource
 */
export interface CompletedPaymentResource extends ProjectDeliverablePaymentResource {
    /**
     * 
     * @type {Date}
     * @memberof CompletedPaymentResource
     */
    paymentDate?: Date;
}

/**
 * Check if a given object implements the CompletedPaymentResource interface.
 */
export function instanceOfCompletedPaymentResource(value: object): value is CompletedPaymentResource {
    return true;
}

export function CompletedPaymentResourceFromJSON(json: any): CompletedPaymentResource {
    return CompletedPaymentResourceFromJSONTyped(json, false);
}

export function CompletedPaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedPaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
    };
}

export function CompletedPaymentResourceToJSON(value?: CompletedPaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate']).toISOString()),
    };
}

